import { useCallback } from 'react';
import { useSnackbar } from 'notistack';

export default function useErrors() {
    const { enqueueSnackbar } = useSnackbar();

    const setErrors = useCallback(
        errors => {
            if (!errors) return;

            if (!errors.response) {
                enqueueSnackbar('Sistema sem resposta', { variant: 'error' });
                return;
            }

            const { status } = errors.response;

            if (status === 401) {
                if (errors.response.data?.error == 'refresh_token_reject') {
                    enqueueSnackbar('Faça o login novamente.', { variant: 'error' });
                }
                return;
            }

            if (status === 404) {
                const message = errors.response.data?.message;
                enqueueSnackbar(
                    typeof message === 'string' && message.trim()
                        ? message
                        : 'Caminho não encontrado',
                    { variant: 'error' },
                );
                return;
            }

            if (errors.response.data) {
                if (Array.isArray(errors.response.data.message)) {
                    errors.response.data.message.forEach(item => {
                        enqueueSnackbar(item.message, { variant: 'error' });
                    });
                    return;
                }

                if (errors.response.data.message) {
                    enqueueSnackbar(errors.response.data.message, { variant: 'error' });
                    return;
                }
            }

            if (errors.response.message) {
                enqueueSnackbar(errors.response.data, { variant: 'error' });
                return;
            }

            enqueueSnackbar('Servidor indisponível. Já estamos revisando!', { variant: 'warning' });
        },
        [enqueueSnackbar],
    );

    return { setErrors, enqueueSnackbar };
}
